import { useIntl } from 'react-intl';
import { Flex } from '@/ui/Flex/Flex';
import { IconStartHometimerSecondary } from '@/icons';
import { T } from '@/ui/Text/Text';
import HorizontalDivider from '@/ui/HorizontalDivider';
import { ActionStartHometimerNodeType } from '../../Nodes/types';
import { GeneralSettingsType } from '../types';
import { StyledSettings } from '../styles';
import FAQSection from '../FAQSection';

function StartHomeTimerSettings({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  settings,
  selectedNode,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  updateNodeData,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  disabled,
}: {
  settings: GeneralSettingsType;
  selectedNode: ActionStartHometimerNodeType;
  updateNodeData: (id: string, newData: any) => void;
  disabled?: boolean;
}) {
  const intl = useIntl();

  const faqs = [
    {
      question: intl.formatMessage({
        defaultMessage: 'How does the Hometimer work?',
        id: 'ClrIK+',
      }),
      answer: intl.formatMessage({
        defaultMessage:
          'The Hometimer is the time after which the system will show the home slide if no trihow lies on a sensor.',
        id: 'TXBTmh',
      }),
    },
    {
      question: intl.formatMessage({
        defaultMessage: 'Where can I change the Hometimer?',
        id: 'iGkIge',
      }),
      answer: intl.formatMessage({
        defaultMessage:
          'You can change the Hometimer in the general settings. You can open the general settings by clicking outside of the currect block.',
        id: 'zz8hpb',
      }),
    },
  ];
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const relevantData = selectedNode.data.options;

  return (
    <StyledSettings data-testid="action-startHometimer-settings">
      <Flex align="center" gap={8}>
        <IconStartHometimerSecondary />
        <Flex direction="column">
          <T h3>
            {intl.formatMessage({
              defaultMessage: 'Start Hometimer',
              id: 'DPCwdW',
            })}
          </T>
        </Flex>
      </Flex>
      <HorizontalDivider />

      <FAQSection faqs={faqs} />
    </StyledSettings>
  );
}
export default StartHomeTimerSettings;
